import axios from 'axios' // 引入axios
import Cookie from 'js-cookie'
import jsonp from 'jsonp'
import { tools } from '~/assets/tools/tools'
import signMd5Utils from './signMd5Utils'
import { debounce } from 'throttle-debounce'
import { get as _get } from 'lodash-es'

const getIp = () => {
    axios.get('https://v4.ident.me/myip').then(res => {
        window.returnCitySN = {
            cip: res.data
        }
    })
}
getIp()


let errTimeArr = [];//每次异常触发的时间
let netErrorTipsFrequency = null //配置

const debounceFunc = debounce(5000, () => {
    // console.log('查询ip', returnCitySN.cip)

    getIp()
    const domainCheckMode = _get(
        $app.$store.state,
        'app.appConfig.app_config.configValue.check_domain_h5_config.mode',
        null
    )
    const showDialog = _get($app.$store.state, 'app.changeLineState.show', false)
    if (domainCheckMode === 1 || domainCheckMode === 2) {
        if (!showDialog) {
            const LxToast = document.querySelector('.lx-toast')
            if (LxToast) {
                LxToast.style.display = 'block'
            }

            $app.$toast(
                `<div class="noNetToast"><div>请检查网络连接! ${window.returnCitySN ? `(${window.returnCitySN.cip})` : ''}</div><div class="changeWrap"><p onclick="$app.$store.dispatch('app/getDomain', 0)"><i></i><span>线路切换</span></p><p onclick="$app.$store.dispatch('app/getDomain', 1)"><i></i><span>网络诊断</span></p></div></div>`,
                {
                    duration: '5000'
                }
            )

        }
    } else {
        $app.$toast(`请检查网络连接! (${window.returnCitySN ? window.returnCitySN.cip : ''})`)
    }
})

const showModelFn = async () => {
    await getIp()
    const domainCheckMode = _get(
        $app.$store.state,
        'app.appConfig.app_config.configValue.check_domain_h5_config.mode',
        null
    )
    const showDialog = _get($app.$store.state, 'app.changeLineState.show', false)
    if (domainCheckMode === 1 || domainCheckMode === 2) {
        if (!showDialog) {
            const LxToast = document.querySelector('.lx-toast')
            if (LxToast) {
                LxToast.style.display = 'block'
            }

            //每次调用当前时间乃最大值
            let { num, timeDiff } = netErrorTipsFrequency
            let maxTime = +new Date()
            let minTime = maxTime - timeDiff

            //检测时间段内触发了几次异常
            errTimeArr = errTimeArr.filter(ele => ele >= minTime && ele <= maxTime)

            console.warn(errTimeArr, '11111')
            //触发次数小于配置次数时立即弹框
            if (errTimeArr.length < num) {
                errTimeArr.push(maxTime)
                $app.$toast(
                    `<div class="noNetToast"><div>请检查网络连接! ${window.returnCitySN ? `(${window.returnCitySN.cip})` : ''}</div><div class="changeWrap"><p onclick="$app.$store.dispatch('app/getDomain', 0)"><i></i><span>线路切换</span></p><p onclick="$app.$store.dispatch('app/getDomain', 1)"><i></i><span>网络诊断</span></p></div></div>`,
                    {
                        duration: '5000'
                    }
                )

            } else if (errTimeArr.length >= num && maxTime - errTimeArr[0] >= timeDiff) {
                //当弹框次数 >=配置的次数时 并且第一次弹框的时间是否与当前的差值》=配置的间隔时间
                errTimeArr = []
            }
        }
    } else {
        //每次调用当前时间乃最大值
        let { num, timeDiff } = netErrorTipsFrequency
        let maxTime = +new Date()
        let minTime = maxTime - timeDiff

        //检测时间段内触发了几次异常
        errTimeArr = errTimeArr.filter(ele => ele >= minTime && ele <= maxTime)

        //触发次数小于配置次数时立即弹框
        if (errTimeArr.length < num) {
            errTimeArr.push(maxTime)
            $app.$toast(`请检查网络连接! (${window.returnCitySN ? window.returnCitySN.cip : ''})`)

        } else if (errTimeArr.length >= num && maxTime - errTimeArr[0] >= timeDiff) {
            //当弹框次数 >=配置的次数时 并且第一次弹框的时间是否与当前的差值》=配置的间隔时间
            errTimeArr = []
        }

    }
}


//发送是仅携带加密加密参数
export const originalinstance = axios.create({
    timeout: 20000 // 请求超时时间
})

originalinstance.interceptors.request.use(
    async config => {
        const uuid = tools.uuid()
        const sign = signMd5Utils.getSign(uuid)
        config.headers['x-auth-uu'] = uuid
        config.headers['x-auth-sign'] = sign

        return config
    },
    error => {
        return Promise.reject(error)
    }
)

const instance = axios.create({
    timeout: 20000 // 请求超时时间
})

// 请求
instance.interceptors.request.use(
    async config => {
        try {
            let Token = $app.$store.state.user.token || Cookie.get('TOKEN')
            config.headers['x-auth-token'] = Token || ''
        } catch (e) {
            console.warn('本次请求没得TOKEN')
        }

        const uuid = tools.uuid()
        const sign = signMd5Utils.getSign(uuid)
        config.headers['x-auth-uu'] = uuid
        config.headers['x-auth-sign'] = sign
        config.baseURL = window.$domain
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 返回
instance.interceptors.response.use(
    async res => {
        // console.info(res)
        let token = res.headers['x-auth-token']
        if (token && res.data.code == '12200') {
            $app.$store.commit('user/setToken', token)
            Cookie.set('TOKEN', token)
        }

        switch (parseInt(res.data.code)) {
            case 8911:
                //维护
                $app._router.replace({ path: '/maintenance', query: { item: JSON.stringify(res.data) } })
                $app.$store.commit('app/setAppReady', true)
                return Promise.resolve(res.data)

            case 8403:
                //403地区限制
                $app._router.replace({ path: '/403' })
                $app.$store.commit('app/setAppReady', true)
                return Promise.resolve(res.data)

            case 401:
                console.log($app.$store.getters)

                const is_error_alter = $app.$store.getters['app/off_line_config'].is_error_alter

                // if ($app.$store.state.user.token.length != 0) {

                // }
                $app.$store.commit('user/setToken', '')
                $app.$store.commit('user/setUserInfo', {})
                $app.$store.commit('user/clearNoReadMsgCountTimer')
                $app.$store.commit('user/clearbalanceTimer')
                // $app.$store.commit('message/setShowHomePop',false)
                $app.$store.commit('user/setShowReadMsg', false)
                $app.$store.commit('user/setNoReadMsgCount', 0)
                $app.$store.commit('user/setImRecent', [])
                $app.$store.commit('user/setImFriendApplyLog', [])

                const notLoginUrl = ['/activityRoomDetails', '/activityRoom']
                const cur_path = $app._router.currentRoute.path
                const isLogin = notLoginUrl.includes(cur_path)

                if (!isLogin) {
                    if (cur_path == '/my') {
                        const isFirstMyNotLogin = $app.$store.state.user.isFirstMyNotLogin
                        if (!isFirstMyNotLogin) {
                            $app.$store.commit('user/setIsFirstMyNotLogin', true)
                            $app._router.push({
                                path: '/login'
                            })
                        }
                    } else {
                        if (is_error_alter == 'y') {
                            $app._router.push({
                                path: '/'
                            })
                            setTimeout(() => {
                                $app.$store.commit('user/setShowOffLineAlert', true)
                            }, 200)
                        } else {
                            $app._router.push({
                                path: '/login'
                            })
                        }
                    }

                }
                return Promise.resolve(res.data)

            case 40002:
                if (res.data.msg != '不弹提示框') {
                    $app.$toast(res.data.msg)
                }
                return Promise.resolve(res.data)
            case 12200:
                if (token) {
                }
                return Promise.resolve(res.data)

            default:
                const c = parseInt(res.data.code)
                if (res.config.url.includes('sysdomain/query') && c == 0) {
                    return Promise.resolve(res.data)
                }
                if (!res.config.self) {
                    if (c != 21308 && c != 400000) {
                        $app.$toast(res.data.msg || '服务器开小差了')
                    }

                }
                return Promise.resolve(res.data)
        }
    },
    error => {

        try {
            let common_config = $app.$store.state.app.appConfig.common_config
            netErrorTipsFrequency = common_config.configValue.netErrorTipsFrequency
        } catch (e) {
            netErrorTipsFrequency = null
        }
        if (netErrorTipsFrequency) {
            showModelFn()
        } else {
            debounceFunc()
        }

        return Promise.resolve({
            code: 'ERROR',
            msg: '请检查网络连接!',
            data: {
                msg: '请检查网络连接',
                code: 'ERROR'
            }
        })
    }
)

export const get = (params, url, self = false) => {
    return instance.get(url, { params })
}
export const post = (params, url, self = false) => {
    return instance.post(url, params, { self })
}
